import {IHttpService} from "angular";
import {ShareAccount} from "../types/AccountManagementRecords";

export class AccountManagementService {

    public static readonly id = "accountManagementService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async detail(accountNumber: string): Promise<ShareAccount> {
        const url = `/tradefloor/api/account-management/account-details/${accountNumber}`;
        const response = await this.$http.get<ShareAccount>(url);
        return response.data;
    }
}
